import { Card, CardBody, CardHeader, CardTitle } from '@/components/ui/card';
import { useMe } from '@/hooks/useMe';
import { Link } from '@tanstack/react-router';

export function ProfilePage() {
  const { data: me, isLoading } = useMe();
  if (isLoading) return <div>Loading…</div>;
  if (!me) return <div>Not signed in.</div>;
  return (
    <Card className="max-w-md">
      <CardHeader>
        <CardTitle>My profile</CardTitle>
      </CardHeader>
      <CardBody className="space-y-2 text-sm">
        <Row label="Username" value={me.username} />
        <Row label="Email" value={me.email ?? '—'} />
        <Row label="Role" value={me.role} />
        <Row label="Status" value={me.status} />
        <Row label="Last login" value={me.last_login_at ?? '—'} />
        <div className="pt-2">
          <Link to="/change-password" className="text-brand-600 hover:underline">
            Change password
          </Link>
        </div>
        <p className="pt-3 text-xs text-slate-500">
          Editing email/phone is owned by Track 6 (Admin & Ops).
        </p>
      </CardBody>
    </Card>
  );
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex gap-3">
      <span className="w-28 text-slate-500">{label}</span>
      <span className="text-slate-900">{value}</span>
    </div>
  );
}
